import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
} from '@validations'
import moment from 'moment'
import {
  today,
  last7,
  last30,
  last60,
  firstDateOfMonth,
  lastDateOfMonth,
  komshipDate,
  last120,
} from '@/store/helpers'
import secureLocalStorage from '@/libs/secureLocalstorage'
import BadgeJuragan from '@/views/components/badge/BadgeJuragan.vue'
import BadgeSaudagar from '@/views/components/badge/BadgeSaudagar.vue'
import BadgeUrgent from '@/views/components/badge/BadgeUrgent.vue'
import BadgeAttachement from '@/views/components/badge/BadgeAttachement.vue'

export default
{
  props: {
    openCollab: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    vSelect,
    DateRangePicker,
    ValidationProvider,
    ValidationObserver,
    BadgeJuragan,
    BadgeSaudagar,
    BadgeUrgent,
    BadgeAttachement,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isVariant: '',
      totalUnread: 0,
      totalUrgent: 0,
      isApplyUrgentFilter: false,
      isApplyFUSFilter: false,
      loadingDataTable: true,
      fieldsTicket: [
        {
          key: 'no_ticket',
          label: 'No. Tiket',
        },
        {
          key: 'awb',
          label: 'Nomor Resi',
        },
        {
          key: 'seller_name',
          label: 'Seller',
        },
        {
          key: 'type_ticket',
          label: 'Jenis Tiket',
        },
        {
          key: 'status_ticket',
          label: 'Status Tiket',
        },
        {
          key: 'created_at',
          label: 'Waktu Dibuat',
        },
        {
          key: 'updated_at',
          label: 'Waktu Diupdate',
        },
      ],
      itemsTicket: [],
      itemsResi: [],

      // Date range picker
      picker: {
        startDate: komshipDate,
        endDate: lastDateOfMonth,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        monthNames: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Mei',
          'Jun',
          'Jul',
          'Agu',
          'Sep',
          'Okt',
          'Nov',
          'Des',
        ],
      },
      ranges: {
        'Semua ': [komshipDate, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Bulan Ini': [firstDateOfMonth, today],
      },
      today,
      last7,
      last30,
      firstDateOfMonth,
      lastDateOfMonth,
      komshipDate,
      imageFile: null,
      imageInitialFile: null,
      itemsImageInitialFile: [],
      selected: true,
      selectMode: 'single',
      perluDiProses: 0,
      perluTindakLanjut: 0,
      sedangDiProses: 0,
      searchType: {
        label: 'Nomor Tiket',
        value: 'ticket_no',
      },
      searchItems: [
        {
          label: 'Nomor Tiket',
          value: 'ticket_no',
        },
        {
          label: 'Nomor Resi',
          value: 'no_resi',
        },
        {
          label: 'Seller',
          value: 'seller_name',
        },
      ],

      // Validation
      required,
      disableButton: false,

      // Store
      loadingSubmitTicket: false,
      itemsNoResi: null,
      noResi: null,
      customerName: '',
      ticketTypeItems: [],
      ticketType: null,
      description: '',
      file: null,

      // Filter
      unreadTicket: [],
      ticketStatus: [],
      ticketStatusItems: [
        {
          label: 'Menunggu Tindak Lanjut',
          value: 0,
          onCheck: false,
        },
        {
          label: 'Perlu Diproses',
          value: 1,
          onCheck: false,
        },
        {
          label: 'Sedang Diproses',
          value: 2,
          onCheck: false,
        },
        {
          label: 'Selesai',
          value: 3,
          onCheck: false,
        },
      ],
      priorityItems: [
        {
          label: 'User Prioritas',
          value: 'UserPrioritas',
          onCheck: false,
        },
      ],
      priority: [],
      fontClassTicketStatus: {
        color: 'salmon',
      },
      search: '',
      filterTicketType: [],
      dateRange: {},
      dateRangeUpdate: {
        startDate: last120,
        endDate: today,
      },
      fcmToken: '',

      // Pagination
      currentPage: 1,
      totalRows: 0,
      optionsPage: [250, 500],
      totalPerPage: 250,

      // count ticket status
      finished: 0,
      received: 0,

      userId: secureLocalStorage.get('userData'),
      colMessage: '2',
      unreadMode: false,

      dropdownFilter: false,
      totalFollowUpSeller: 0,

      isAllType: true,
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.fetchTicket()
      },
    },
    async openCollab(val) {
      if (val === true) {
        await this.defaultFilter()
        await this.fetchTicket()
        await this.fetchTicketMitraCount()
        this.getTypeTicket()
        Notification.requestPermission().then(permission => {
          if (!('permission' in Notification)) {
            Notification.permission = permission
          }
        })
      }
    },
  },
  computed: {
    computedClassFilter() {
      let result = '12'
      if (window.screen.width >= 600) {
        result = 'auto'
      }
      return result
    },
    computedClassAnyFilter() {
      return window.screen.width >= 600 ? 'auto' : '12 mb-1'
    },
  },
  async mounted() {
    Notification.requestPermission().then(permission => {
      if (!('permission' in Notification)) {
        Notification.permission = permission
      }
    })
  },
  methods: {
    defaultFilter() {
      this.dateRange = {
        startDate: last60,
        endDate: today,
      }
    },
    submitFilter(value) {
      if (value === 'FUS') {
        this.isApplyFUSFilter = !this.isApplyFUSFilter
        this.ticketStatus = []
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < this.ticketStatusItems.length; x++) {
          this.ticketStatusItems[x].onCheck = false
        }
        if (this.isApplyFUSFilter) {
          this.ticketStatusItems[2].onCheck = true
          if (!this.ticketStatus.includes(2)) {
            this.ticketStatus.push(2)
          }
        } else {
          this.ticketStatusItems[2].onCheck = false
          this.ticketStatus = this.ticketStatus.filter(item => item !== 2)
        }
      }
      if (value === 'urgent') { this.isApplyUrgentFilter = !this.isApplyUrgentFilter }
      this.fetchTicket()
      this.isVariant = false
    },
    filterStatusFromBox(value) {
      this.ticketStatus = []
      this.ticketStatusItems = [
        {
          label: 'Menunggu Tindak Lanjut',
          value: 0,
          onCheck: false,
        },
        {
          label: 'Perlu Diproses',
          value: 1,
          onCheck: false,
        },
        {
          label: 'Sedang Diproses',
          value: 2,
          onCheck: false,
        },
        {
          label: 'Selesai',
          value: 3,
          onCheck: false,
        },
      ]
      this.ticketStatus.push(value)
      const findIndexObj = this.ticketStatusItems.findIndex(items => items.value === value)
      this.ticketStatusItems[findIndexObj].onCheck = true
      this.fetchTicket()
    },
    async fetchTicket() {
      this.loadingDataTable = true
      const params = {
        per_page: this.totalPerPage,
        page: this.currentPage,
      }
      if (this.dateRange) {
        Object.assign(params, { start_date: `${this.formatDateParams(this.dateRange.startDate)} 00:00:00` })
        Object.assign(params, { end_date: `${this.formatDateParams(this.dateRange.endDate)} 23:59:59` })
      }
      if (this.ticketStatus.length > 0) Object.assign(params, { status_ticket: this.ticketStatus.join() })
      if (this.search) Object.assign(params, { search: this.search })
      if (this.filterTicketType.length > 0) Object.assign(params, { type_ticket_id: this.filterTicketType.join() })
      if (this.isApplyFUSFilter) { Object.assign(params, { unread: true }) }

      await this.$http_collaborator.get('/ticket/api/v1/ticket/mitra/list', {
        params,
      })
        .then(response => {
          if (response.data.code !== 400) {
            this.itemsTicket = response.data.data.tickets
            this.totalRows = response.data.data.total
            this.loadingDataTable = false
          } else {
            this.itemsTicket = []
            this.loadingDataTable = false
          }
          if (this.isApplyFUSFilter) { this.getFollowUpSellerCount(params) }
          if (this.isApplyUrgentFilter) { this.getUrgentCount(params) }
        })
        .catch(err => {
          this.itemsTicket = []
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: err.response.data.message,
              variant: 'danger',
            },
          }, 2000)
          this.loadingDataTable = false
        })
    },
    fetchTicketMitraCount() {
      this.$http_collaborator.get('/ticket/api/v1/ticket/mitra/count-ticket')
        .then(response => {
          this.perluDiProses = response.data.data.pending_shipment
          this.perluTindakLanjut = response.data.data.waiting_seller
          this.sedangDiProses = response.data.data.in_transit
          this.finished = response.data.data.completed
          this.received = response.data.data.successfully_received
        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: err.response.data.message,
              variant: 'danger',
            },
          }, 2000)
        })
    },
    fetchDataResi() {
      this.customerName = this.itemsNoResi.receiver_name
      this.noResi = this.itemsNoResi.awb
    },
    alertSubmitTicket() {
      this.$refs.formRules.validate().then(success => {
        if (success) {
          this.$refs['alert-validate-ticket'].show()
        } else {
          this.loadingSubmitTicket = false
        }
      })
    },
    closeAlertSubmitTicket() {
      this.$refs['alert-validate-ticket'].hide()
    },
    submitTicket() {
      this.$refs.formRules.validate().then(success => {
        if (success) {
          this.$refs['loading-create-ticket'].show()
          const formData = new FormData()
          formData.append('awb', this.noResi)
          formData.append('type_ticket_id', this.ticketType.id)
          formData.append('description', this.description)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.itemsImageInitialFile.length; i++) {
            formData.append('attachments', this.itemsImageInitialFile[i])
          }

          this.$http_collaborator.post('/ticket/api/v1/ticket/mitra/create', formData)
            .then(() => {
              this.loadingSubmitTicket = false
              this.noResi = null
              this.itemsNoResi = null
              this.customerName = ''
              this.ticketType = null
              this.description = ''
              this.itemsImageInitialFile = []
              this.$refs['loading-create-ticket'].hide()
              this.$refs['popup-success-create-ticket'].show()
              this.$refs['modal-create-ticket'].hide()
            })
            .catch(err => {
              this.$refs['loading-create-ticket'].hide()
              this.$refs['modal-failure-create-ticket'].show()
            })
        }
      })
    },
    closeSuccessCreateTicket() {
      this.fetchTicket()
      this.$refs['popup-success-create-ticket'].hide()
    },
    onRowSelected(selectedItems) {
      const selectedItem = selectedItems[0]
      const index = this.itemsTicket.findIndex(items => items.awb === selectedItem.no_ticket)

      const url = this.$router.resolve({
        path: `/kendala-pengiriman/detail-kolaborator/${selectedItem.no_ticket}`,
      })
      window.open(url.href, '_blank')
    },
    cekResi(search, loading) {
      if (search.length) {
        this.searchResi(loading, search, this)
      }
    },
    searchResi: _.debounce((loading, search, that) => {
      loading(true)
      that.loadResi(search).finally(() => loading(false))
    }, 500),
    loadResi(search) {
      return this.$http_collaborator.get(`/ticket/api/v1/ticket/mitra/find/${search}`)
        .then(response => {
          this.itemsResi = response.data.data.awbs
        }).catch(err => {
        })
    },
    getTypeTicket() {
      const params = {
        all: this.isAllType,
      }
      return this.$http_collaborator.get('/ticket/api/v1/ticket/mitra/type-ticket', { params })
        .then(response => {
          this.ticketTypeItems = response.data.data.types
        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: err.response.data.message,
              variant: 'danger',
            },
          }, 2000)
        })
    },
    formatDate(d) {
      return moment(d).format('D MMM YYYY')
    },
    formatDateParams(d) {
      return moment(d).format('YYYY-MM-DD')
    },
    onChangeFile(event) {
      const { files } = event.target
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf']

      const invalidFiles = []
      const validFiles = []

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileExtension = file.name.split('.').pop().toLowerCase()
        const isValidExtension = allowedExtensions.includes(fileExtension)

        if (!isValidExtension) {
          invalidFiles.push(file.name)
        } else {
          validFiles.push(file)
        }
      }

      if (invalidFiles.length > 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failure',
            icon: 'AlertCircleIcon',
            text: `Ekstension yang diperbolehkan: ${allowedExtensions.join(', ')}`,
            variant: 'danger',
          },
        }, 2000)
      }

      if (validFiles.length > 3) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failure',
            icon: 'AlertCircleIcon',
            text: 'Maksimal upload 3 file',
            variant: 'danger',
          },
        }, 2000)
      } else {
        validFiles.forEach(this.myFile)
      }
    },

    myFile(data) {
      this.itemsImageInitialFile.push(data)
    },
    fileUrl: file => (file ? URL.createObjectURL(file) : null),
    deleteFile(data) {
      const findIndexObj = this.itemsImageInitialFile.findIndex(items => items.name === data.name)
      this.itemsImageInitialFile.splice(findIndexObj, 1)
    },
    setSearchType(data) {
      this.searchType = data
      this.fetchTicket()
      this.$root.$emit('bv::hide::popover', 'popover-search-type')
    },
    filterTicketByStatus(data) {
      const findIndexObj = this.ticketStatusItems.findIndex(items => items.value === data.value)
      const findObj = this.ticketStatus.findIndex(items => items === data.value)
      if (this.ticketStatusItems[findIndexObj].onCheck === true) {
        this.ticketStatus.push(data.value)
      } else {
        this.ticketStatus.splice(findObj, 1)
      }
    },
    filterByTicketType(data) {
      const findIndexObj = this.ticketTypeItems.findIndex(items => items.id === data.id)
      const findObj = this.filterTicketType.findIndex(items => items === data.id)
      if (this.ticketTypeItems[findIndexObj].onCheck === true) {
        this.filterTicketType.push(data.id)
      } else {
        this.filterTicketType.splice(findObj, 1)
      }
    },
    filterTicketByPriority(data) {
      const findIndexObj = this.priorityItems.findIndex(items => items.value === data.value)
      const findObj = this.priority.findIndex(items => items === data.value)
      if (this.priorityItems[findIndexObj].onCheck === true) {
        this.priority.push(data.value)
      } else {
        this.priority.splice(findObj, 1)
      }
    },
    statusTicketClass(data) {
      let resultVariant = ''
      if (data === 'Perlu Diproses') {
        resultVariant = 'font-medium text-primary'
      } else if (data === 'Sedang Diproses') {
        resultVariant = 'font-medium text-warning'
      } else if (data === 'Selesai') {
        resultVariant = 'font-medium text-success'
      } else if (data === 'Batal') {
        resultVariant = 'font-medium text-secondary'
      }
      return resultVariant
    },
    statusOrderClass(v) {
      let result = ''
      if (v === 'Diterima') {
        result = 'text-success'
      } else if (v === 'Dipacking' || v === 'Diajukan' || v === 'Dikirim') {
        result = 'text-warning'
      } else if (v === 'Batal' || v === 'Retur' || v === 'Hilang' || v === 'Rusak') {
        result = 'text-primary'
      }
      return result
    },
    statusOrderValue(v) {
      let result = ''
      if (v === 'Diterima') {
        result = '🙌🏻 akhirnya diterima'
      } else if (v === 'Dipacking') {
        result = v
      } else if (v === 'Diajukan') {
        result = v
      } else if (v === 'Batal') {
        result = 'Dibatalkan'
      } else if (v === 'Retur') {
        result = 'Berakhir Return'
      } else if (v === 'Hilang') {
        result = 'Paketnya Hilang 🙏'
      } else if (v === 'Rusak') {
        result = 'Paketnya Rusak 🙏'
      }
      return result
    },
    // eslint-disable-next-line func-names
    searchTicket: _.debounce(function () {
      this.fetchTicket()
    }, 1000),
    async clearFilter() {
      this.search = ''
      this.ticketStatus = []
      this.filterTicketType = []
      this.priority = []
      this.loadingDataTable = true
      this.isApplyUrgentFilter = false
      this.isApplyFUSFilter = false
      this.unreadMode = false
      // eslint-disable-next-line no-plusplus
      for (let x = 0; x < this.ticketTypeItems.length; x++) {
        this.ticketTypeItems[x].onCheck = false
      }
      // eslint-disable-next-line no-plusplus
      for (let x = 0; x < this.ticketStatusItems.length; x++) {
        this.ticketStatusItems[x].onCheck = false
      }
      for (let x = 0; x < this.priorityItems.length; x += 1) {
        this.priorityItems[x].onCheck = false
      }
      await this.defaultFilter()
      await this.fetchTicket()
    },
    convertTicketStatus(data) {
      let result = ''
      if (data === 0) {
        result = 'Menunggu Tindak Lanjut'
      } else if (data === 1) {
        result = 'Perlu Diproses'
      } else if (data === 2) {
        result = 'Sedang Diproses'
      } else if (data === 3) {
        result = 'Selesai'
      } else if (data === 4) {
        result = 'Batal'
      }
      return result
    },
    clearFieldTicket() {
      this.noResi = null
      this.itemsResi = []
      this.itemsNoResi = null
      this.customerName = ''
      this.ticketType = null
      this.description = ''
      this.itemsImageInitialFile = []
      this.$refs.formRules.reset()
      this.isAllType = true
      this.getTypeTicket()
      this.$refs['modal-create-ticket'].hide()
    },
    setPerPage(page) {
      this.totalPerPage = page
      this.fetchTicket()
    },
    checkVariantClear() {
      let result = 'outline-primary'
      if (this.itemsNoResi !== null || this.ticketType !== null || this.itemsImageInitialFile.length !== 0 || this.description !== '') {
        result = 'outline-dark'
      }
      return result
    },
    checkDisableClear() {
      let result = true
      if (this.itemsNoResi !== null || this.ticketType !== null || this.itemsImageInitialFile.length !== 0 || this.description !== '') {
        result = false
      }
      return result
    },
    handleCloseAlert() {
      this.$refs['modal-alert-notification'].hide()
    },
    showModalCreateTicket() {
      this.$refs['modal-create-ticket'].show()
      this.isAllType = false
      this.getTypeTicket()
    },
    getDateCreate(data) {
      const date = moment(data).format('DD MMMM YYYY')
      const result = `${date}`
      return result
    },
    getHoursCreate(data) {
      const hours = moment(data).format('HH.MM')
      const result = `${hours} WIB`
      return result
    },
    getDateUpdate(data) {
      const date = moment(data).format('DD MMMM YYYY')
      const result = `${date}`
      return result
    },
    getHoursUpdate(data) {
      const hours = moment(data).format('HH.MM')
      const result = `${hours} WIB`
      return result
    },
    handlePopupCreateTicket() {
      this.$refs['modal-create-ticket'].show()
      this.$refs['modal-failure-create-ticket'].hide()
    },
    getRowClass(item, type) {
      let result = null
      if (item) {
        result = item.history_ticket_count_partner !== null ? '' : 'table-secondary'
      }
      return result
    },
    getFollowUpSellerCount(params) {
      this.$http_komship
        .get('/v1/ticket-mitra/follow-up-seller', { params })
        .then(response => {
          this.totalFollowUpSeller = response.data.data.total
        })
        .catch(err => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Failure',
                icon: 'AlertCircleIcon',
                text: err.response.data.message,
                variant: 'danger',
              },
            },
            2000,
          )
        })
    },
  },
}
